import React from "react";

const AdditionalChargesApply = ({ className = "" }) => {
  return <p className={className}>Additional charges may apply.</p>;
};

export default AdditionalChargesApply;
